import { useQuery } from "@tanstack/react-query";
import { getAuth, multiFactor, TotpMultiFactorGenerator } from "firebase/auth";

export const useMfa = () => {
    return useQuery({
        queryKey: ["mfa-factors"],
        queryFn: () => {
            const user = getAuth().currentUser;

            if (!user) return null;

            return (
                multiFactor(user).enrolledFactors.find(
                    (f) => f.factorId === TotpMultiFactorGenerator.FACTOR_ID,
                ) ?? null
            );
        },
    });
};
